export const PARTNER_ROLE_PROPERTY_MANAGER = 'Property Manager';
export const PARTNER_ROLE_OWNER = 'Owner';
export const PARTNER_ROLE_AGENT = 'Agent';

export const PARTNER_BILLING_PLAN_LITE = 'Lite';
export const PARTNER_BILLING_PLAN_BASE = 'Base';
export const PARTNER_BILLING_PLAN_FULL_SERVICE = 'Full Service';
export const PARTNER_BILLING_PLAN_SAAS = 'SaaS';
export const PARTNER_BILLING_PLANS = [
  PARTNER_BILLING_PLAN_LITE,
  PARTNER_BILLING_PLAN_BASE,
  PARTNER_BILLING_PLAN_FULL_SERVICE,
  PARTNER_BILLING_PLAN_SAAS,
];

export const PARTNER_STATUS_DRAFT = 'Draft';
export const PARTNER_STATUS_ACTIVE = 'Active';
export const PARTNER_STATUS_ARCHIVED = 'Archived';

export const PARTNER_BILLING_PLAN_OPTION_ITEMS = PARTNER_BILLING_PLANS.map((billingPlan) => ({
  label: billingPlan,
  value: billingPlan,
}));

export const PARTNER_TYPE_AGENT = 'Agent';
export const PARTNER_TYPE_PROPERTY_MANAGER = 'Property Manager';
export const PARTNER_TYPE_MULTI_FAMILY = 'Multi-Family';

export const PARTNER_TYPES = [
  PARTNER_TYPE_AGENT,
  PARTNER_TYPE_PROPERTY_MANAGER,
  PARTNER_TYPE_MULTI_FAMILY,
];

export const PROPERTY_MANAGER_TYPE_INDIVIDUAL = 'Individual';
export const PROPERTY_MANAGER_TYPE_BUSINESS = 'Business';

export const PARTNER_DEFAULT_MASTER_LOCK_CODE = '1267';
export const PARTNER_DEFAULT_COMMISSION_PERCENTAGE = 0.65;

export const PARTNER_CRM_TYPE_APPFOLIO = 'Appfolio';

export const PARTNER_DEFAULT_DATA = {
  billingPlan: PARTNER_BILLING_PLAN_FULL_SERVICE,
  marketPropertyRequireExistingListingFlag: false,
  amenityPhotosEnabled: true,
  stripeConnectedAccountsEnabled: true,
  logoUrl: 'https://media-partner-logos.s3.amazonaws.com/sunroom.png',
  accountManagerUserId: 161934, // Kirsty
  salesRepUserId: 126201, // Cody Frank
  status: PARTNER_STATUS_ACTIVE,
};

export const MOBILE_APP_DOWNLOAD_LINK = 'http://onelink.to/u7pccx'; // eslint-disable-line max-len

export const PARTNER_AGENT_SIGNUP_TYPE_LISTING_AGENT = 'ListingAgent';
export const PARTNER_AGENT_SIGNUP_TYPE_BUYERS_AGENT = 'BuyersAgent';
export const PARTNER_AGENT_SIGNUP_TYPE_TENANT_SCREENING = 'TenantScreening';
export const PARTNER_AGENT_SIGNUP_TYPE_SUNRISE = 'SunRise';
export const PARTNER_AGENT_SIGNUP_TYPE_OTHER = 'Other';
export const PARTNER_AGENT_SIGNUP_TYPE_UTILITY_PROFIT = 'UtilityProfit';

export const PARTNER_SIGNUP_TYPE_SUN_SCREEN = 'SunScreen';
export const PARTNER_SIGNUP_TYPE_SUN_RISE = 'SunRise';
export const PARTNER_SIGNUP_TYPE_FULL_SERVICE = 'FullService';

export const PARTNER_SIGNUP_PROVIDER_API = 'API';
export const PARTNER_SIGNUP_PROVIDER_SIGNUP_FORM = 'signupForm';

export const partnerAgentSignupTypeOptionItems = [
  {
    label: 'I have properties I want to lease with Sunroom.',
    value: PARTNER_AGENT_SIGNUP_TYPE_LISTING_AGENT,
  },
  {
    label: 'I have a renter client interested in a property listed on Sunroom.',
    value: PARTNER_AGENT_SIGNUP_TYPE_BUYERS_AGENT,
  },
  {
    label: 'Other',
    value: PARTNER_AGENT_SIGNUP_TYPE_OTHER,
  },
];

export const partnerFullServiceAgentSignupTypes = [
  PARTNER_AGENT_SIGNUP_TYPE_LISTING_AGENT,
  PARTNER_AGENT_SIGNUP_TYPE_BUYERS_AGENT,
  PARTNER_AGENT_SIGNUP_TYPE_OTHER,
];

export const PARTNER_COLLECT_FIRST_MONTH_TIME_SECURITY_DEPOSIT_PAYMENT = 'securityDepositPayment';
export const PARTNER_COLLECT_FIRST_MONTH_TIME_MOVE_IN = 'moveIn';

export const PARTNER_ID_STONE_OAK = 2;
export const PARTNER_ID_DOORVEST = 27;
export const PARTNER_ID_3Z_PROPERTIES = 243;
export const PARTNER_ID_HOMERIVER = 1378;
export const PARTNER_ID_ASHOKA_LION = 513;
export const PARTNER_ID_PATHWAY_HOMES = 1914;
export const PARTNER_ID_LIV_INDY = 1928;

export const PARTNER_LEASING_REFERRAL_AGREEMENT_2023 =
  'https://s3.amazonaws.com/sr-media-prod/2023-leasing-referral-agreement.pdf'; // eslint-disable-line max-len

export const PARTNER_NOTIFICATION_TYPE_TEXT = 'text';
export const PARTNER_NOTIFICATION_TYPE_EMAIL = 'email';
export const PARTNER_NOTIFICATION_TYPE_PUSH = 'push';
